export default __webpack_public_path__ + "static/media/wv.3e6d58c1.png";